import styled from 'styled-components';

export const Label = styled.label`
  font-weight: 500;
  font-size: 14px;
  font-family: var(--set-page-base-font-family);
  line-height: 1.5;
`;
